import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './styles/iconlibrary'
import '@shoelace-style/shoelace/dist/components/card/card.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';


@customElement('sales-card')
export class SalesCard extends LitElement {

  @property({ type: String, attribute: 'title' 		})	title: string = ''
  @property({ type: String, attribute: 'sub-title' 	}) 	subtitle: string = ''
  @property({ type: String, attribute: 'icon' 		})	icon: string = ''
  @property({ type: String, attribute: 'value' 		})	value: string = ''
  @property({ type: String, attribute: 'sub-value' 	})  subvalue: string = ''
  @property({ type: String, attribute: 'info' 		})	info: string = ''

  @property({ type: Boolean, attribute: 'is-positive' })
  isPositive: boolean = true;

  static styles = css`
    :host {
        xdisplay: block;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;    }

    sl-card {
        flex: 1; 
        display: flex;
        box-shadow: rgba(1, 41, 112, 0.1) 0px 0px 30px 0px;
        width: 100%;
    }

    sl-card::part(base) {
        display: flex;
        flex-direction: column;
        height: 100%;       
        flex: 1 1 auto;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    sl-card::part(header) {
        border-bottom: none;
        flex: 0 0 auto;
		font-weight: 500;
        font-size: 1.2rem;

    }

    sl-card::part(body) {
        padding-top: 0px;
        xborder: 1px solid rgb(229, 229, 229);
        border-top: none;
        background-color: white;
        flex: 1 1 auto;
        overflow: auto; /* allow scrolling if needed */
        display: flex;
        flex-direction: column;
    }

    .container {
		display: flex;
    }

	.icon {
		display: flex;
		justify-content: center; 
		align-items: center;     
	}

    .main {
		flex: 1;
		display: flex;
		flex-direction: column;      
		justify-content: center;     
		align-items: center;         
    }

    .side-icon {
	      font-size: 5rem;
    }

	.sub-title {
        font-weight: normal;
        font-size: .8rem;
		border-left: 1px solid grey;
		padding-left: .5rem;
	}

	.value {
		font-size: 3rem;
		font-weight: 800;
	}
  `;

  render() {
    return html`
        <sl-card class="card-header">
            <div slot="header">
                ${this.title} 
				${this.subtitle? html`<span class="sub-title">${this.subtitle}</span>`: ''}
            </div>
            <div class="container">
				<div class="icon">
                	<sl-icon-button name="${this.icon}" library="voxy-icons" class="side-icon"></sl-icon-button>
				</div>
                <div class="main">
                    <div class="value">${this.value}</div>
                    <div class="details"><em>${this.subvalue}</em> ${this.info}</details>
                </div>
            </div>
        </sl-card>
    `;
  }
}

// TypeScript declaration for the custom element
declare global {
  interface HTMLElementTagNameMap {
    'sales-card': SalesCard;
  }
}

// Example usage:
// <sales-card 
//   title="Sales" 
//   subtitle="Today" 
//   icon="cart"
//   value="145" 
//   percentage="12%" 
//   percentage-text="increase"
//   is-positive>
// </sales-card>

// Available Shoelace icons for the icon property:
// cart, bag, cash-coin, graph-up, trending-up, pie-chart, 
// bar-chart, activity, dollar-sign, credit-card, etc.